import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IQrCodeSuccessResponse } from '../../../entity/interface/iQrCodes';

export interface IQrAuthenticateCodeUseCase {
    execute(apiKey: string, qrCode: string, token: string, identityToken: string): Promise<boolean>;
}

export class QrAuthenticateCodeUseCase implements IQrAuthenticateCodeUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(apiKey: string, qrCode: string, token: string, identityToken: string): Promise<boolean> {
        const response = await this.userRepo.qrAuthenticateCode(apiKey, qrCode, token, identityToken);
        return response.result?.data?.status?.toUpperCase() === 'SUCCESS';
    }
}
